import React, {Fragment, useEffect} from 'react'

import {useLang} from '@_metronic/i18n/Metronici18n'

import useCatalogsStore, {CatalogCodeName} from '@app/store/useCatalogStore'
import useIsPremium from '@app/hooks/useIsPremium'

import CatalogField from './components/CatalogField'

import {SimValuesType} from '../EditSimDrawerContent'

type EditSimCatalogParamsProps = {
  allSimValues: SimValuesType
  values: any
  visibleCodeNames?: string[]
  hiddenCodeNames?: string[]
  onChange: (updatedValues: any) => void
  onAllValuesChange: (updatedValues: SimValuesType) => void
}
const EditSimCatalogParams = ({
  allSimValues,
  values = {},
  visibleCodeNames,
  hiddenCodeNames,
  onChange,
  onAllValuesChange,
}: EditSimCatalogParamsProps) => {
  // console.log('### EditSimCatalogParams', values, allSimValues.type)
  const {loadCatalogs, catalogs} = useCatalogsStore()
  // console.log('### catalogs', catalogs)

  useEffect(() => {
    loadCatalogs()
  }, [])

  const catalogsFilteredByType = catalogs
    ?.filter((catalog) => {
      if (visibleCodeNames) {
        return visibleCodeNames.includes(catalog.code_name)
      }

      if (hiddenCodeNames) {
        return !hiddenCodeNames.includes(catalog.code_name)
      }
    })
    .filter((catalog) => {
      if (allSimValues.type === 0) {
        return catalog.code_name !== CatalogCodeName.animal_personality_traits
      }

      return catalog.code_name === CatalogCodeName.animal_personality_traits
    }).filter((catalog)=>catalog.code_name !== "skills")
  // console.log('### catalogsFilteredByType', allSimValues.type, catalogsFilteredByType)

  const language = useLang()
  const isPremium = useIsPremium()

  return (
    <>
      {catalogsFilteredByType?.map((catalog) => {

        // console.log('### catalogsFilteredByType.map', {values, code_name: catalog.code_name})
        const fieldValues = values[catalog.code_name] || []
        const catalogName = catalog.translate.name[language]
          ? catalog.translate.name[language]
          : catalog.name

        const oldFieldName =
          catalog.code_name === CatalogCodeName.animal_personality_traits
            ? CatalogCodeName.character_traits
            : catalog.code_name

        return (
          <Fragment key={catalog.code_name}>
            {typeof allSimValues[oldFieldName] !== 'undefined' ? (
              <div className='mb-10'>
                <label className='form-label'>{catalogName}</label>
                <input
                  type='text'
                  value={allSimValues[oldFieldName]}
                  className='form-control'
                  placeholder=''
                  onChange={(e) =>
                    onAllValuesChange({...allSimValues, [oldFieldName]: e.currentTarget.value})
                  }
                />
              </div>
            ) : null}
            <CatalogField
              key={catalog.code_name}
              disabled={!isPremium}
              catalog={catalog}
              values={fieldValues}
              onChange={(value) => {
                onChange({...values, [catalog.code_name]: value})
              }}
              onDeleteOutdatedValue={() => {
                const allSimValuesClone = {...allSimValues}
                onAllValuesChange(allSimValuesClone)
              }}
            />
          </Fragment>
        )
      })}
    </>
  )
}

export default React.memo(EditSimCatalogParams)
